import { FC } from "react";

import { useSelector } from 'react-redux';
import { ISettingOptions } from "../../../types/interfaces";

import styles from "../headerBtn.module.scss";

const VacantRoutesSettingsSection: FC<ISettingOptions> = ({
  setSelectedSettings,
  selectedSettings,
  setIsCheckedFullInfo,
  isCheckedFullInfo,
}) => {
  const { claims } = useSelector((state: any) => state.user.user.data);
  const options = [
    (((claims.includes('admin') || claims.includes('projects:list'))) && { value: "project", label: "Проект" }),
    { value: "routeNo", label: "Номер маршрута" },
    { value: "login", label: "Логин" },
    { value: "routeType", label: "Тип маршрута" },
    { value: "vacancyName", label: "Название вакансии" },
    { value: "vsv", label: "ВСВ" },
    { value: "supervisor", label: "Супервайзер" },
    { value: "tt", label: "Кол-во ТТ на маршруте" },
    { value: "visitsOnWeek", label: "Плановое кол-во визитов в неделю" },
    { value: "income", label: "Выручка" },
    { value: "plannedWage", label: "Зарплата" },
  ].filter((option) => !!option);
  const handleChangeCheckbox = (name: string) => {
    const updatedSettings = selectedSettings.includes(name)
      ? selectedSettings.filter((elem: string) => elem !== name)
      : [...selectedSettings, name];

    setSelectedSettings(updatedSettings);
    setIsCheckedFullInfo(false);
  };
  const handleChangeFullInfoCheckbox = () => {
    if (!isCheckedFullInfo) {
      const allSettings = options.map((option) => option.value);
      setSelectedSettings(allSettings);
    } else {
      setSelectedSettings([]);
    }
    setIsCheckedFullInfo(!isCheckedFullInfo);
  };

  return (
    <div className={styles.settings__block_info}>
      <div className={styles.check__list_block}>
        {options.map((option) => (
          <div key={option.value} className={styles.check__list_elem}>
            <label className={styles.checkbox__container}>
              <input
                checked={selectedSettings.includes(option.value)}
                type="checkbox"
                onChange={() => handleChangeCheckbox(option.value)}
              />
              <span className={styles.multi__reason_checkmark}></span>
            </label>
            {option.label}
          </div>
        ))}
        <div className={styles.check__list_elem}>
          <label className={styles.checkbox__container}>
            <input
              type={"checkbox"}
              onChange={handleChangeFullInfoCheckbox}
              checked={isCheckedFullInfo || (options.length === selectedSettings.length)}
            />
            <span className={styles.multi__reason_checkmark}></span>
          </label>
          Все
        </div>
      </div>
    </div>
  );
};

export default VacantRoutesSettingsSection;
